<template lang="html">
  <section class="app-read-award" role="tablist">
    <b-card no-body class="mb-1" :key="idx" v-for="(award, idx) in awards">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="" v-b-toggle="'accordion-'+idx" variant="light">{{award.name}}</b-button>
      </b-card-header>
      <b-collapse :id="'accordion-'+idx" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="d-flex">
            <img :src="encodeURI(getBaseURL + award.src)" :alt="award.name" class="img-fluid img-thumbnail w-25">
            <div class="d-flex flex-wrap justify-content-between">
              <div><strong>award_id : </strong>{{award.award_id}}</div>
              <div><strong>date_created : </strong>{{award.date_created}}</div>
              <div><strong>date_uploaded : </strong>{{award.date_uploaded}}</div>
              <div><strong>date_updated : </strong>{{award.date_uploaded}}</div>
              <div><strong>link : </strong>{{award.link}}</div>
              <div><strong>name : </strong>{{award.name}}</div>
              <div><strong>date_issued : </strong>{{award.date_issued}}</div>
              <div><strong>date_expiration : </strong>{{award.date_expiration}}</div>
              <div><strong>issuing_org_name : </strong>{{award.issuing_org_name}}</div>
              <div><strong>issuing_org_link : </strong>{{award.issuing_org_link}}</div>
              <div><strong>description : </strong>{{award.description}}</div>
              <div><strong>src : </strong>{{award.src}}</div>
              <div><strong>type : </strong>{{award.type}}</div>
            </div>
          </b-card-text>
          <b-card-text class="mt-4 text-center">
            <button type="button" class="btn btn-primary"
                    @click="navigateAway({id: award.award_id, title: award.name}, 'update')">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3"
                    @click="navigateAway({id: award.award_id, title: award.name}, 'delete')">
              Delete
            </button>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
export default {
  name: 'ReadAward',
  props: [],
  mounted () {},
  created () {
    this.readData()
      .then(data => this.awards = data)
      .catch()
  },
  data () {
    return {
      awards: null
    }
  },
  methods: {
    ...mapActions([
      'setCurrentElement',
      'setOperation',
      'setCrudComponent',
      'setPreviousOperation',
      'readData'
    ]),
    navigateAway(object, tab) {
      this.setCurrentElement(object);
      this.setPreviousOperation(this.getOperation);
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentElement',
      'getOperation',
      'getComponent',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-read-award {}
  .bgTextColor{
    background-color: var(--dark-color);
    color: var(--white-color);
  }
</style>



// WEBPACK FOOTER //
// src/components/awards/ReadAward.vue